exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#block{border:2px solid #ccc}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/admin/settings/Pages/sections/multiple_blocks.vue"],"names":[],"mappings":"AACA,OACI,qBAAuB,CAC1B","file":"multiple_blocks.vue","sourcesContent":["\n#block {\n    border: #ccc solid 2px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-45eb34a6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/admin/settings/Pages/sections/multiple_blocks.vue
// module id = 1382
// module chunks = 2